module.exports = __webpack_public_path__ + "static/img/yiNew3.f2c2b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiNew3.jpg
// module id = rV0S
// module chunks = 0